import Cookies from 'js-cookie'

const TOKEN_KEY = 'TRANS_TOKEN'

const USER_KEY = 'TRANS_USER'

const CONFIG_KEY = 'TRANS_CONFIG'

const MANUAL_LOGOUT_KEY = 'TRANS_MANUAL_LOGOUT'


export function getToken() {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  try {
    const persistedState = JSON.parse(localStorage.getItem('vuex') || '{}')
    return persistedState.user && persistedState.user.token
  } catch (error) {
    return ''
  }
}

export function setToken(token) {
  clearManualLogout()
  return Cookies.set(TOKEN_KEY, token)
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY)
}

export function setUserInfo(userinfo) {
  return Cookies.set(USER_KEY, userinfo)
}

export function setConfig(config) {
  return Cookies.set(CONFIG_KEY, config)
}
export function getConfig() {
  return Cookies.get(CONFIG_KEY)
}

export function removeConfig() {
  return Cookies.remove(CONFIG_KEY)
}

export function markManualLogout() {
  try {
    sessionStorage.setItem(MANUAL_LOGOUT_KEY, '1')
  } catch (error) {}
}

export function isManualLogout() {
  try {
    return sessionStorage.getItem(MANUAL_LOGOUT_KEY) === '1'
  } catch (error) {
    return false
  }
}

export function clearManualLogout() {
  try {
    sessionStorage.removeItem(MANUAL_LOGOUT_KEY)
  } catch (error) {}
}
